module.exports = __webpack_public_path__ + "img/Group 11413.7ca76c10.png";